module.exports = __webpack_public_path__ + "files/dcc11f98204aac3e66f71921d6a8f8c7.png";